// imports here
import axios from 'axios'

// const variables
const BASE_URL = 'http://localhost:8000/app/client/companies'
const BASE_IMG_URL = 'http://localhost:8000/app/client/logo'


// initial state
const state = {
  items: [],
  item: {},
  totalItems: 0,
  pagination: {},
  errors: null,
  loading: false
}

// getters
const getters = {
  companies: state => state.items,
  rowPerPageItems: state => state.pagination.rowsPerPage ? state.pagination.rowsPerPage : [10, 20, 30, 40, 50],
  pagination: state => state.pagination,
  hasErrors: state => state.errors,
  isLoading: state => state.loading
}

// mutations
const mutations = {
  setCompanies: (state, payload) => {
    state.items = payload.data
    state.pagination.page = payload.meta.current_page
    state.pagination.rowsPerPage = payload.meta.per_page
    state.totalItems = payload.meta.total
  },
  updateCompanyItem: (state, payload) => {
    const index = state.items.findIndex(item => item.id === payload.id)
    state.items[index][payload.key] = payload.value
  },
  setErrors: (state, payload) => state.errors = payload,
  setLoading: (state, payload) => state.loading = payload
}

// actions
const actions = {
  async getCompanies (context, page) {
    context.commit('setErrors', null)
    context.commit('setLoading', true)
    try {
      const page_number = page.page || context.state.pagination.page
      const rowsPerPage = page.rowsPerPage || context.state.pagination.rowsPerPage
      const response = await axios.get(`${BASE_URL}?page=${page_number}&rowsPerPage=${rowsPerPage}`)
      context.commit('setCompanies', response.data)
      context.commit('setLoading', false)
    } catch (error) {
      context.commit('setErrors', error.response.data)
      context.commit('setLoading', false)
    }
  },
  async createCompany (context, payload) {
    context.commit('setErrors', null)
    context.commit('setLoading', true)
    try {
      const response = await axios.post(`${BASE_URL}/store`, payload)
      return Promise.resolve(response)
    } catch (error) {
      context.commit('setErrors', error.response.data)
      context.commit('setLoading', false)
    }
  },
  async updateCompany (context, payload) {
    context.commit('setErrors', null)
    try {
      const response = await axios.put(`${BASE_URL}/update`, payload)
      return Promise.resolve(response)
    } catch (error) {
      context.commit('setErrors', error.response.data)
    }
  },
  async deleteCompany (context, payload) {
    context.commit('setErrors', null)
    try {
      const response = await axios.delete(`${BASE_URL}/${payload.id}`)
      return Promise.resolve(response)
    } catch (error) {
      context.commit('setErrors', error.response.data)
    }
  },
  async uploadImage (context, payload) {
    context.commit('setErrors', null)
    try {
      const response = await axios.post(`${BASE_IMG_URL}/store`, payload)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error.response.data.errors)
    }
  },
  updateCompanyItem: ({ commit }, payload) => commit('updateCompanyItem', payload),
  setErrors: ({ commit }, payload) => commit('setErrors', payload),
  setLoading: ({ commit }, payload) => commit('setLoading', payload)
}

// export variables with namespaced
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
